export const state = {
  classrooms: [],
  headerClassrooms: [],
  loadingClassrooms: true
}

